import { TSelectOption } from '@interfaces/components/componentTypes';
import { TTableFilter } from '@interfaces/components/table';

interface IGetFiltersType {
	selectedAssetOwnerName: TSelectOption;
	selectedRequestStatus: TSelectOption;
	setSelectedAssetOwnerName: (name: TSelectOption) => void;
	setSelectedRequestStatus: (status: TSelectOption) => void;
	requestsStatuses: any;
	organisations: Array<TSelectOption>;
}

export function getFilters({
	selectedAssetOwnerName,
	setSelectedAssetOwnerName,
	selectedRequestStatus,
	setSelectedRequestStatus,
	requestsStatuses,
	organisations,
}: IGetFiltersType): Array<TTableFilter> {
	return [
		{
			name: 'assetOwnerId',
			placeholder: 'Asset Owner Name',
			option: selectedAssetOwnerName,
			options: organisations,
			minWidth: '200px',
			setState: setSelectedAssetOwnerName,
			defaultValue: 'All',
		},
		{
			name: 'requestStatus',
			placeholder: 'Request Status',
			option: selectedRequestStatus,
			options: requestsStatuses,
			minWidth: '200px',
			setState: setSelectedRequestStatus,
			defaultValue: 'All',
		},
	];
}
